import React from 'react';

const AddTask = ({ isOpen, setIsOpen, showTaskRate, setTaskRate, taskRate }) => {
    if (!isOpen) return null;
    return (
        <>
            <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
                <div
                    className="custom-modal-content"
                    onClick={(e) => e.stopPropagation()} // Prevent closing on content click
                >
                    <h2 className="oms-modal-title">Add Task</h2>
                    <form className="oms-modal-form">
                        {/* task Name */}
                        <div className="oms-form-group">
                            <label htmlFor="task-name" className="oms-form-label">
                                Task Name
                            </label>
                            <input
                                type="text"
                                id="task-name"
                                placeholder="Enter task name"
                            />
                        </div>
                        {/* task Name */}
                        <div className="oms-form-group">
                            <label htmlFor="task-description" className="oms-form-label">
                                Task description
                            </label>
                            <input
                                type="text"
                                id="task-description"
                                placeholder="Enter task description"
                            />
                        </div>

                        {/* Per/Hour Rate */}
                        {showTaskRate && (
                            <div className="oms-form-group">
                                <label htmlFor="taskRate" className="oms-form-label">
                                    Rate/Hour [INR]
                                </label>
                                <input
                                    type="number"
                                    id="taskRate"
                                    placeholder="Enter rate per hour"
                                    value={taskRate}
                                    onChange={(e) => setTaskRate(e.target.value)}
                                />
                            </div>
                        )}


                        {/* Actions */}
                        <div className="oms-form-actions">
                            <button type="button" onClick={() => setIsOpen(false)}>
                                Cancel
                            </button>
                            <button type="submit">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}


export default AddTask;